import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { Gesture as DrawIcon, Keyboard as TypeIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { SignatureMode } from '../../types';

type Props = {
  mode: SignatureMode;
  onModeChange: (mode: SignatureMode) => void;
  disabled?: boolean;
};

export const SignatureModeToggle = ({
  mode,
  onModeChange,
  disabled = false
}: Props) => {
  const { t } = useTranslation('customerReview');
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={(_, newMode) => {
        if (newMode !== null) {
          onModeChange(newMode);
        }
      }}
      size="small"
      disabled={disabled}
      sx={{
        mb: 2,
        '& .MuiToggleButton-root': {
          padding: '6px 16px',
          fontSize: '0.875rem',
          gap: 1,
          '&.Mui-selected': {
            backgroundColor: isDarkMode
              ? 'rgba(109, 211, 224, 0.2)'
              : 'rgba(1, 103, 124, 0.1)',
            color: isDarkMode ? '#6dd3e0' : '#01677C',
            borderColor: isDarkMode ? '#6dd3e0' : '#01677C',
            '&:hover': {
              backgroundColor: isDarkMode
                ? 'rgba(109, 211, 224, 0.3)'
                : 'rgba(1, 103, 124, 0.2)'
            }
          }
        }
      }}
    >
      <ToggleButton value="draw">
        <DrawIcon fontSize="small" />
        {t('acknowledgment.signatureModes.draw')}
      </ToggleButton>
      <ToggleButton value="type">
        <TypeIcon fontSize="small" />
        {t('acknowledgment.signatureModes.type')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
